import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["aria-label", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainIcon = _resolveComponent("MainIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "mobile-bar border-t border-border-subtle bg-[rgba(249,246,240,0.9)] text-text-primary backdrop-blur-md",
    style: _normalizeStyle(_ctx.mobileBarStyle)
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link, index) => {
      return (_openBlock(), _createElementBlock("button", {
        key: index,
        type: "button",
        class: "mobile-bar-icon",
        "aria-label": link.label,
        onClick: ($event: any) => (_ctx.iconAction(link))
      }, [
        _createVNode(_component_MainIcon, {
          size: "1.6em",
          background: false,
          icon: link.icon,
          color: "currentColor"
        }, null, 8, ["icon"])
      ], 8, _hoisted_1))
    }), 128))
  ], 4))
}